module.exports = __webpack_public_path__ + "img/1514038286.32aa5896.jpg";